module.exports = __webpack_public_path__ + "img/acciona.e33c9c40.png";